import { lazy } from "react";

// route
export const fRoute = { path: "/facility", name: "menu.facility", icon: "business" };
export const fCategoryRoute = { path: `${fRoute.path}/category`, name: "facility_category.", icon: "" };
export const fTransListRoute = { path: `${fRoute.path}/trans-list`, name: "facility_list.", icon: "" };
export const fMasterRoute = { path: `${fRoute.path}/master`, name: "facility_master.", icon: "" };
export const fMasterCreateRoute = { path: `${fMasterRoute.path}/create`, name: "facility_master.add", icon: "" };
export const fMasterEditRoute = { path: `${fMasterRoute.path}/edit`, name: "facility_master.add", icon: "" };
export const fMasterUploadRoute = { path: `${fMasterRoute.path}/upload`, name: "facility_master.upload", icon: "" };

// component
const Facility = lazy(() => import("../page/facility/Facility"));
const FMaster = lazy(() => import("../page/facility/master/MaterFacility"));
const FMasterForm = lazy(() => import("../page/facility/master/form/MaterFacilityForm"));
const FMasterUpload = lazy(() => import("../page/facility/master/upload/MasterFacilityUpload"));
const FCategory = lazy(() => import("../page/facility/master_category/MasterFacilityCategory"));
const FTransList = lazy(() => import("../page/facility/list/FacilityList"));

export const facilityListRoutes = [
    fMasterRoute, fCategoryRoute, fTransListRoute
]

export const facilityMutationRoute = [
    fMasterCreateRoute, fMasterEditRoute, fMasterUploadRoute
]

export const facilityRoutes = {
    element: <Facility />,
    children: [
        { ...fMasterRoute, element: <FMaster /> },
        { ...fMasterCreateRoute, element: <FMasterForm /> },
        { ...fMasterEditRoute, element: <FMasterForm /> },
        { ...fMasterUploadRoute, element: <FMasterUpload /> },
        { ...fCategoryRoute, element: <FCategory /> },
        { ...fTransListRoute, element: <FTransList /> },
    ]
}